// Definition of AntDesign Constants

export default {
    theme: {
        token: {
            colorPrimary: '#1677ff',
            fontFamily: 'IRANSansFaNum, Tahoma, Arial, sans-serif'
        },
    }
};
